import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PuebloBase } from '@components/pueblo-base.component';
import { EMPTY_INTEREST } from '@utils/defaults';

@Component({
  selector: 'interest-info-dialog',
  templateUrl: 'interest-info-dialog.component.html',
  styleUrl: 'interest-info-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterestInfoDialog extends PuebloBase {
  readonly $interest = input(EMPTY_INTEREST, {
    alias: 'interest',
  });
}
